module.exports = __webpack_public_path__ + "static/media/logo-harvard-bmi-on.ea7a8c32.svg";